import React from "react";
import {  useSelector } from "react-redux";
import { languageLable } from "utilities/helpers";
import AccountLinks from '../AccountLinks';
import InvoiceTable from "./InvoiceTable"

export default function DueInvoice() {

    const appState = useSelector(state => state)
    const { selectedLanguageData } = appState.app;

    return (
        <section className="ps-my-account ps-page--account">
            <div className="ps-container">
                <div className="row">
                    <AccountLinks page="due-invoice" />
                    <div className="col-lg-8">
                        <div className="ps-page__content">
                            <div className="ps-section--account-setting">
                                <div className="ps-section__header">
                                    <h3>{languageLable(selectedLanguageData, "Due Invoice")} </h3>
                                </div>
                                <div className="ps-section__content">
                                    <InvoiceTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
